import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const Contact = ({ content }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
    // Reset form after submission
    setFormData({ name: '', email: '', message: '' });
    alert('Message sent! (This is a demo)');
  };

  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h2 className="text-3xl font-bold mb-6">{t('contact.title')}</h2>
            <p className="text-gray-600 mb-8">{t('contact.description')}</p>
            <div className="space-y-4">
              {content.info.map((item, index) => (
                <div key={index} className="flex items-center">
                  <FontAwesomeIcon 
                    icon={item.icon === 'envelope' ? faEnvelope : item.icon === 'phone' ? faPhone : faMapMarkerAlt} 
                    className="text-custom w-6" 
                  />
                  <span className="ml-4 text-gray-600">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t('contact.name')}
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-custom focus:border-custom"
                placeholder={t('contact.name')}
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t('contact.email')}
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-custom focus:border-custom"
                placeholder={t('contact.email')}
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t('contact.message')}
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-custom focus:border-custom h-32"
                placeholder={t('contact.message')}
                required
              />
            </div>
            <button 
              type="submit" 
              className="rounded-button w-full bg-custom text-white py-3 font-medium hover:bg-custom/90"
            >
              {t('contact.send')}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
